module.exports = __webpack_public_path__ + "assets/montserrat-medium.cb90ab16ff3ecccaea4d114d23b3464b.woff2";